import { render, staticRenderFns } from "./resendActivationCode.vue?vue&type=template&id=42dc1f8c&scoped=true"
import script from "./resendActivationCode.vue?vue&type=script&lang=js"
export * from "./resendActivationCode.vue?vue&type=script&lang=js"
import style0 from "./resendActivationCode.vue?vue&type=style&index=0&id=42dc1f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc1f8c",
  null
  
)

export default component.exports